import type { FC, ReactNode } from "react";
import type { PinCandidateRow as PinCandidateRowData } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/usePinCandidateRows";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	row: PinCandidateRowData;
	icon: ReactNode;
	iconBg?: string;
	isLast: boolean;
	disabled: boolean;
	onClick: () => void;
};

export const PinCandidateRow: FC<Props> = ({
	row,
	icon,
	iconBg,
	isLast,
	disabled,
	onClick,
}) => (
	<ListRow
		onClick={onClick}
		disabled={disabled}
		icon={icon}
		iconBg={iconBg}
		title={row.title}
		subtitle={row.subtitle}
		isLast={isLast}
	/>
);
